(function () {
  window.dataLayer = window.dataLayer || [];

  document.addEventListener('click', function (e) {
    var card = e.target.closest('xo-product');
    if (!card) return;
    /*if (e.target.closest('button, input, [data-add-to-cart]')) return;*/
    if (e.target.closest('button, input, [data-add-to-cart], [role="button"], xo-cart-remove')) return;

    var link = e.target.closest('a[href]') || card.querySelector('a[href]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;

    var d = card.dataset;
    console.log('SELECT_ITEM', d);
    var item = {
      item_id: d.sku || d.variantId || card.getAttribute('xo-product-id') || '',
      item_name: d.title,
      item_brand: d.vendor,
      item_category: d.type || 'N/A',
      item_variant: d.variantTitle || undefined,
      price: parseFloat(d.price) || undefined,
      index: d.index != null ? parseInt(d.index, 10) : 0
    };

    e.preventDefault();

    var done = false;
    function go() {
      if (done) return;
      done = true;
      window.location.href = href;
    }

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: 'select_item',
      ecommerce: {
        item_list_id: d.listId || '',
        item_list_name: d.listName || '',
        items: [item]
      },
      eventCallback: go,
      eventTimeout: 1000
    });

    setTimeout(go, 1000);
  }, true);
})();

(function () {
  window.dataLayer = window.dataLayer || [];

  function pushFromCart() {
    
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(cart => {
        console.log('CART:',cart);
        const item = cart.items[cart.items.length - 1]; // ultimo aggiunto
        if (!item) return;
        console.log('ITEM:',item);
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            currency: cart.currency,                          // dal cart
            value: +(item.final_price / 100).toFixed(2),
            items: [{
              item_id: item.sku || String(item.variant_id),   // dal cart
              item_name: item.product_title,                  // dal cart
              item_variant: item.variant_title || undefined,  // dal cart
              price: +(item.final_price / 100).toFixed(2),     // dal cart (centesimi → euro)
              quantity: 1                          // dal cart
            }]
          }
        });
      });
      
  }

  // intercetta l'aggiunta al carrello e poi rilegge il cart
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const url = (args[0] && args[0].url) || args[0] || '';
    return origFetch.apply(this, args).then(res => {
      if (typeof url === 'string' && /\/cart\/add/.test(url)) {
        setTimeout(pushFromCart, 200);
      }
      return res;
    });
  };
})();


/* =============================================================================
 * Cart custom – fatturazione, fidelity, pacchetto regalo, analytics
 * -----------------------------------------------------------------------------
 * Refactor:
 *  - Fix race condition: la Partita IVA (e gli altri campi fattura) veniva
 *    salvata solo su `blur` con fetch fire-and-forget. Cliccando "Checkout"
 *    la navigazione partiva prima che la fetch si completasse → ordine senza
 *    P.IVA. Ora al checkout si fa un salvataggio BLOCCANTE (con keepalive) e la
 *    navigazione avviene solo dopo la conferma.
 *  - Consolidati i due handler `click` sul pulsante checkout in uno solo.
 *  - Consolidati i due handler della radio "Vuoi ricevere la fattura?".
 *  - Aggiornamenti carrello serializzati (niente più corse concorrenti che si
 *    sovrascrivono a vicenda).
 *  - Fix bug selettore mancante del punto ('.') nel branch di nascondimento.
 *  - Rimosso l'hack su Element.prototype.siblings.
 * ============================================================================= */
(function () {
  'use strict';

  /* ---------------------------------------------------------------------------
   * Helper generici
   * ------------------------------------------------------------------------- */
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function attrName(name) { return 'attributes[' + name + ']'; }
  function byAttr(name) { return $('[name="' + attrName(name) + '"]'); }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait || 300);
    };
  }

  function showError(id, msg) {
    var el = document.getElementById(id);
    if (!el) return;
    if (msg) el.innerHTML = '<small>' + msg + '</small>';
    el.removeAttribute('hidden');
  }
  function hideError(id) {
    var el = document.getElementById(id);
    if (el) el.setAttribute('hidden', 'true');
  }

  /* ---------------------------------------------------------------------------
   * CartAttributes: coda serializzata per cart/update.js
   * Evita che update concorrenti si sovrascrivano (last-write-wins di Shopify).
   * ------------------------------------------------------------------------- */
  var CartAttributes = (function () {
    var endpoint = ROOT + 'cart/update.js';
    var queue = Promise.resolve();

    function push(data, opts) {
      opts = opts || {};
      var body = new FormData();
      Object.keys(data).forEach(function (key) {
        body.append(attrName(key), data[key] == null ? '' : data[key]);
      });

      function run() {
        return fetch(endpoint, {
          method: 'POST',
          body: body,
          keepalive: !!opts.keepalive
        })
          .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
          .catch(function (err) { console.error('[cart] update fallito', err); });
      }

      // Concatena sempre (sia in caso di successo che di errore precedente).
      queue = queue.then(run, run);
      return queue;
    }

    return { push: push };
  })();

  function changeLineProperties(line, properties) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, properties: properties })
    })
      .then(function (r) { return r.json(); })
      .catch(function (err) { console.error('[cart] change fallito', err); });
  }

  /* ---------------------------------------------------------------------------
   * Validatori di formato
   * ------------------------------------------------------------------------- */
  function isVatValid(v) { v = (v || '').trim(); return v.length === 11 || v.length === 13; }
  function isFiscalIdValid(v) { return (v || '').trim().length === 7; }
  function isPecValid(v) { v = (v || '').trim(); return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  /* =========================================================================
   * INIT – solo nella pagina carrello
   * ========================================================================= */
  function initCartCustom() {
    if (!$('.cart-custom-section-wrap')) return;

    /* -----------------------------------------------------------------------
     * FATTURAZIONE
     * --------------------------------------------------------------------- */
    var BILLING_FIELDS = ['Ragione sociale', 'Partita IVA', 'Indirizzo PEC', 'Identificativo Fiscale'];

    var fakeId = document.getElementById('fake-identificativo-fiscale');
    var realId = document.getElementById('identificativo-fiscale');
    var vatEl  = document.getElementById('partita-iva');
    var pecEl  = document.getElementById('indirizzo-pec');

    function collectBilling() {
      var out = {};
      BILLING_FIELDS.forEach(function (name) {
        var el = byAttr(name);
        if (el) out[name] = el.value;
      });
      return out;
    }

    function setBillingVisible(visible) {
      $$('.cart-custom-field-billing-group, .cart-custom-field-billing').forEach(function (f) {
        f.style.display = visible ? 'block' : 'none';
      });
      $$('.cart-custom-field-billing.cart-custom-field-billing-required input, ' +
         '.cart-custom-field-billing.cart-custom-field-billing-required select').forEach(function (input) {
        input.required = visible;
        input.classList.toggle('required', visible);
      });

      if (!visible) {
        $$('.cart-custom-field-billing input, .cart-custom-field-billing select').forEach(function (el) {
          if (el.tagName === 'SELECT') el.selectedIndex = 0; else el.value = '';
        });
        $$('.cart-custom-field-billing-group .invalid-feedback span').forEach(function (s) {
          s.setAttribute('hidden', 'true');
        });
      }
    }

    var lastInvoiceChoice = null;
    function onBillingToggle(force) {
      var checked = $('.custom-radio-partita-iva:checked');
      if (!checked) return;
      if (!force && checked.value === lastInvoiceChoice) return; // dedup click+change
      lastInvoiceChoice = checked.value;

      var wantsInvoice = checked.value === 'Si';
      setBillingVisible(wantsInvoice);

      var payload = { 'Vuoi ricevere la fattura?': checked.value };
      if (wantsInvoice) {
        Object.assign(payload, collectBilling());
      } else {
        BILLING_FIELDS.forEach(function (name) { payload[name] = ''; });
      }
      CartAttributes.push(payload);
    }

    // iOS Safari: sui radio "custom" `change` a volte non scatta → ascolto anche `click`.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('custom-radio-partita-iva')) onBillingToggle();
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.classList.contains('custom-radio-partita-iva')) onBillingToggle();
    });

    // Sync campo fake → campo reale Identificativo Fiscale.
    function syncRealId() {
      if (realId) realId.value = fakeId.value !== '' ? fakeId.value.toUpperCase() : '0000000';
    }
    if (fakeId && realId) {
      fakeId.addEventListener('input', syncRealId);
    }

    // Salvataggio dei campi fattura (debounced + serializzato).
    var saveBilling = debounce(function () { CartAttributes.push(collectBilling()); }, 250);

    BILLING_FIELDS.forEach(function (name) {
      var el = byAttr(name);
      if (el) el.addEventListener('blur', saveBilling);
    });

    // Validazione formato al blur.
    if (vatEl) {
      vatEl.addEventListener('blur', function () {
        if (vatEl.value.trim() === '' || isVatValid(vatEl.value)) hideError('partitaiva-is-required-input');
        else showError('partitaiva-is-required-input', '* Inserisci 11 o 13 caratteri');
      });
    }
    if (fakeId) {
      fakeId.addEventListener('blur', function () {
        syncRealId();
        if (fakeId.value.trim() === '' || isFiscalIdValid(fakeId.value)) hideError('codiceSDI_error-is-required-input');
        else showError('codiceSDI_error-is-required-input', "* L'identificativo deve avere 7 caratteri");
        saveBilling(); // include il valore reale sincronizzato
      });
    }
    if (pecEl) {
      pecEl.addEventListener('blur', function () {
        if (pecEl.value.trim() === '' || isPecValid(pecEl.value)) hideError('codiceSDI_error-is-required-input');
        else showError('codiceSDI_error-is-required-input', "* Ricontrollare l'indirizzo PEC");
      });
    }

    /* -----------------------------------------------------------------------
     * FIDELITY CARD
     * --------------------------------------------------------------------- */
    var lastFidelityChoice = null;
    function onFidelityToggle(force) {
      var checked = $('.custom-radio-fidelity:checked');
      if (!checked) return;
      if (!force && checked.value === lastFidelityChoice) return;
      lastFidelityChoice = checked.value;

      var active = checked.value === 'Si';

      $$('.cart-custom-field-fidelity').forEach(function (f) {
        f.style.display = active ? 'block' : 'none';
      });
      $$('.cart-custom-field-fidelity.cart-custom-field-fidelity-required input, ' +
         '.cart-custom-field-fidelity.cart-custom-field-fidelity-required select').forEach(function (input) {
        input.required = active;
        input.classList.toggle('required', active);
      });

      var payload = { 'Fidelity card?': checked.value };
      if (active) {
        var cardEl = byAttr('Fidelity card');
        payload['Fidelity card'] = cardEl ? cardEl.value : '';
      } else {
        $$('.cart-custom-field-fidelity input, .cart-custom-field-fidelity select').forEach(function (el) {
          el.value = '';
        });
        hideError('fidelity-is-required-input');
        payload['Fidelity card'] = '';
      }
      CartAttributes.push(payload);
    }

    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('custom-radio-fidelity')) onFidelityToggle();
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.classList.contains('custom-radio-fidelity')) onFidelityToggle();
    });

    // Salvataggio campi fidelity al blur.
    var fidelityCard = byAttr('Fidelity card');
    if (fidelityCard) {
      fidelityCard.addEventListener('blur', debounce(function () {
        CartAttributes.push({ 'Fidelity card': fidelityCard.value });
      }, 250));
    }

    /* -----------------------------------------------------------------------
     * VALIDAZIONE + CHECKOUT (handler unico)
     * --------------------------------------------------------------------- */

    // Campi required vuoti (fidelity + fattura) → ritorna il primo campo in errore.
    function firstEmptyRequired() {
      var fields = $$('.cart-custom-section-wrap [required][data-error-id]');
      for (var i = 0; i < fields.length; i++) {
        var input = fields[i];
        var errId = (input.getAttribute('data-error-id') || '').trim();
        if (!input.value || input.value.trim() === '') {
          showError(errId);
          return input;
        }
        hideError(errId);
      }
      return null;
    }

    // Validazione formato specifica fattura. Ritorna {ok, focus}.
    function validateBillingFormat() {
      var checked = $('.custom-radio-partita-iva:checked');
      if (!checked || checked.value !== 'Si') return { ok: true };

      if (vatEl && !isVatValid(vatEl.value)) {
        showError('partitaiva-is-required-input', '* Inserisci 11 o 13 caratteri');
        return { ok: false, focus: vatEl };
      }

      var idFilled  = fakeId && fakeId.value.trim() !== '';
      var pecFilled = pecEl && pecEl.value.trim() !== '';
      var idOk  = idFilled && isFiscalIdValid(fakeId.value);
      var pecOk = pecFilled && isPecValid(pecEl.value);

         // Se la PEC è compilata, la sua validità va SEMPRE controllata
    // (anche quando l'Identificativo è valido).
    if (pecFilled && !pecOk) {
      showError('codiceSDI_error-is-required-input', "* Ricontrollare l'indirizzo PEC");
      return { ok: false, focus: pecEl };
    }

    // Almeno uno tra Identificativo (7 char) e PEC valida.
    if (!idOk && !pecOk) {
      if (idFilled && !isFiscalIdValid(fakeId.value)) {
        showError('codiceSDI_error-is-required-input', "* L'identificativo deve avere 7 caratteri");
        return { ok: false, focus: fakeId };
      }
      showError('codiceSDI_error-is-required-input', '* Obbligatorio');
      return { ok: false, focus: pecEl || fakeId };
    }


      hideError('codiceSDI_error-is-required-input');
      return { ok: true };
    }

    // Bind su TUTTI i pulsanti checkout (incluso eventuale sticky su mobile,
    // che era la causa più probabile della P.IVA persa).
    var submitting = false;
    $$('[name="checkout"]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        if (submitting) return; // salvataggio già avviato: lascia procedere
        event.preventDefault();

        var empty = firstEmptyRequired();
        if (empty) { empty.focus(); return; }

        var fmt = validateBillingFormat();
        if (!fmt.ok) { if (fmt.focus) fmt.focus.focus(); return; }

        // Consenso Condizioni Generali di Vendita
        var terms = document.getElementById('CartTerms');
        if (terms && !terms.checked) {
          terms.reportValidity();
          terms.focus();
          return;
        }

        // Salvataggio BLOCCANTE prima di navigare.
        submitting = true;
        syncRealId();

        var checked = $('.custom-radio-partita-iva:checked');
        var payload = { 'Vuoi ricevere la fattura?': checked ? checked.value : 'No' };
        if (checked && checked.value === 'Si') Object.assign(payload, collectBilling());

        CartAttributes.push(payload, { keepalive: true }).then(function () {
          window.location.href = ROOT + 'checkout';
        });
      });
    });

    /* -----------------------------------------------------------------------
     * PACCHETTO REGALO (line item properties via cart/change.js)
     * --------------------------------------------------------------------- */
    function giftProperties(wrap, container, fraseValue) {
      var misura = container && container.querySelector('.misura-value');
      var radio  = wrap && wrap.querySelector('.custom-cart-pacchetto-regalo-radio');
      var props = {
        'Pacchetto regalo': radio ? radio.value : '',
        'Frase biglietto auguri': fraseValue
      };
      if (misura && misura.value) props['Misura'] = misura.value;
      return props;
    }

    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.classList.contains('custom-cart-pacchetto-regalo-radio')) return;

      var wrap = e.target.closest('.cart-regalo-option-wrap');
      var container = e.target.closest('.custom-cart-pacchetto-regalo');
      var fraseEl = wrap && wrap.querySelector('.custom-frase-pacchetto-regalo');
      var misura = container && container.querySelector('.misura-value');

      var props = {
        'Pacchetto regalo': e.target.value,
        'Frase biglietto auguri': fraseEl ? fraseEl.value : ''
      };
      if (misura && misura.value) props['Misura'] = misura.value;

      changeLineProperties(e.target.getAttribute('data-line'), props);

      // UI
      var row = e.target.closest('tr');
      if (row) {
        row.querySelectorAll('.custom-cart-pacchetto-regalo-radio.active')
          .forEach(function (el) { el.classList.remove('active'); });
        row.querySelectorAll('.custom-frase-pacchetto-regalo-wrap')
          .forEach(function (el) { el.style.display = 'none'; });
      }
      e.target.classList.add('active');
      var fraseWrap = wrap && wrap.querySelector('.custom-frase-pacchetto-regalo-wrap');
      if (fraseWrap) fraseWrap.style.display = 'block';
    });

    document.addEventListener('blur', function (e) {
      if (!e.target || !e.target.classList || !e.target.classList.contains('custom-frase-pacchetto-regalo')) return;
      var wrap = e.target.closest('.cart-regalo-option-wrap');
      var container = e.target.closest('.custom-cart-pacchetto-regalo');
      changeLineProperties(
        e.target.getAttribute('data-line'),
        giftProperties(wrap, container, e.target.value)
      );
    }, true);

    // Sincronizza la frase tra le opzioni "fratelle" mentre si digita.
    function syncFrase(e) {
      if (!e.target || !e.target.classList || !e.target.classList.contains('custom-frase-pacchetto-regalo')) return;
      var value = e.target.value;
      var wrap = e.target.closest('.cart-regalo-option-wrap');
      if (!wrap || !wrap.parentNode) return;
      Array.prototype.slice.call(wrap.parentNode.children).forEach(function (sib) {
        if (sib === wrap || !sib.matches('.cart-regalo-option-wrap')) return;
        sib.querySelectorAll('.custom-frase-pacchetto-regalo').forEach(function (input) {
          input.value = value;
        });
      });
    }
    document.addEventListener('keydown', syncFrase);
    document.addEventListener('keyup', syncFrase);

    /* -----------------------------------------------------------------------
     * Stato iniziale
     * --------------------------------------------------------------------- */
    onFidelityToggle(true);
    onBillingToggle(true);
  }

  /* =========================================================================
   * ANALYTICS + TOAST (fuori dal contesto carrello)
   * ========================================================================= */
  function initRegistrationToast() {
    if (window.location.search.indexOf('customer_posted=true') === -1) return;
    var toast = document.getElementById('registration-toast');
    if (!toast) return;

    setTimeout(function () { toast.classList.remove('toast-hidden'); }, 500);
    window.history.replaceState(null, null, window.location.pathname);
    setTimeout(function () { toast.classList.add('toast-hidden'); }, 10000);
  }

  function initAnalytics() {
    var formRegister = document.getElementById('create_customer');
    if (formRegister) {
      formRegister.addEventListener('submit', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'sign_up', method: 'email', form_type: 'account_registration' });
      });
    }

    var formNewsletter = document.getElementById('ContactFooter');
    if (formNewsletter) {
      formNewsletter.addEventListener('submit', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'sign_up', method: 'email', form_type: 'newsletter' });
      });
    }
  }

  /* =========================================================================
   * Bootstrap
   * ========================================================================= */
  function boot() {
    initCartCustom();
    initRegistrationToast();
    initAnalytics();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


(function() {
  document.addEventListener("DOMContentLoaded", function() {
    // Controlla se l'URL contiene il parametro ?registrazione=ok
    if (window.location.search.indexOf('customer_posted=true') > -1) {
      
      var toast = document.getElementById('registration-toast');
      
      // Mostra il banner
      setTimeout(function() {
        toast.classList.remove('toast-hidden');
      }, 500);

      // Pulisci URL
      window.history.replaceState(null, null, window.location.pathname);

      // Nascondi automaticamente dopo 5 secondi
      setTimeout(function() {
        toast.classList.add('toast-hidden');
      }, 10000);
    }
  });
})();

document.addEventListener('DOMContentLoaded', function() {

  // Registrazione account
  var formRegister = document.getElementById('create_customer');
  if (formRegister) {
    formRegister.addEventListener('submit', function() {

      console.log("ACCOUNT registration");
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'sign_up',
        method: 'email',
        form_type: 'account_registration'
      });
    });
  }

  // Newsletter
  var formNewsletter = document.getElementById('ContactFooter');
  if (formNewsletter) {
    formNewsletter.addEventListener('submit', function() {
      console.log("NL registration");
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'sign_up',
        method: 'email',
        form_type: 'newsletter'
      });
    });
  }

});


/* CUSTOM SYNESTHESIA - messaggio "Riservato a ristoratori" sticky */
(function () {
  var box = document.querySelector('.alternative-message-box');
  if (!box) return;

  var GAP = 10; // spazio tra menù e messaggio quando è sticky (px)

  var style = document.createElement('style');
  style.textContent =
    '.alternative-message-box.is-stuck{' +
      'position:fixed;z-index:900;' +
      'transition:padding .25s ease,box-shadow .25s ease}' +
    '.alternative-message-box.is-stuck p{' +
      '}' + '.xo-section:has(.alternative-message-box.is-stuck){z-index:950}';
  document.head.appendChild(style);

  var ph = document.createElement('div'); // evita il salto del layout
  ph.style.display = 'none';
  box.parentNode.insertBefore(ph, box);

  function headerOffset() {
    var h = document.querySelector('.xo-header__sticky');
    return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0;
  }

  function update() {
    var stuck = box.classList.contains('is-stuck');
    var off = headerOffset() + GAP;
    var top = (stuck ? ph : box).getBoundingClientRect().top;

    if (!stuck && top <= off) {
      ph.style.height = box.offsetHeight + 'px';
      ph.style.display = 'block';
      box.classList.add('is-stuck');
    } else if (stuck && ph.getBoundingClientRect().top > off) {
      box.classList.remove('is-stuck');
      box.style.left = box.style.width = box.style.top = '';
      ph.style.display = 'none';
    }
    if (box.classList.contains('is-stuck')) {
      var p = ph.getBoundingClientRect();
      box.style.top = off + 'px';
      box.style.left = p.left + 'px';
      box.style.width = p.width + 'px';
    }
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
/* FINE CUSTOM SYNESTHESIA */